// apiKeyClient — P-004: client-wrappers för api_key-RPCs (DB-backed,
// separat från pure apiKeyManager.ts som är in-memory-lib).
//
// Enterprise-only issue (server-trigger); list/revoke öppet för alla
// authenticated (users som har nycklar kan revoke:a även om tier har
// downgrade:ats).
//
// Security-note: `issueApiKey()` returnerar plaintext-token EN gång.
// Klienten BÖR copy-to-clipboard + visa "spara nu"-UX — det går inte
// att läsa token:n från DB senare (lagrat som SHA-256-hash).

import { callRpc } from '@/lib/supabaseTyped';

export type ApiKeyScope = 'runs:trigger' | 'runs:read' | 'workflows:read';

export interface ApiKeyMetadata {
  id: string;
  label: string;
  scopes: string[];
  last_used_at: string | null;
  revoked_at: string | null;
  expires_at: string | null;
  created_at: string;
}

export interface IssueApiKeyResult {
  success: boolean;
  id?: string;
  /** Plaintext-token — visas bara EN gång. */
  token?: string;
  label?: string;
  scopes?: string[];
  expires_at?: string | null;
  error?: string;
}

export async function issueApiKey(
  label: string,
  scopes: ApiKeyScope[] = ['runs:trigger'],
  expiresInDays?: number,
): Promise<IssueApiKeyResult> {
  const { data, error } = await callRpc<{
    success: boolean;
    id?: string;
    token?: string;
    label?: string;
    scopes?: string[];
    expires_at?: string | null;
    error?: string;
  }>('issue_api_key', {
    p_label: label,
    p_scopes: scopes,
    p_expires_in_days: expiresInDays ?? null,
  });
  if (error) return { success: false, error: error.message };
  return data ?? { success: false, error: 'empty-response' };
}

export async function revokeApiKey(id: string): Promise<{ success: boolean; error?: string }> {
  const { data, error } = await callRpc<{ success: boolean; error?: string }>(
    'revoke_api_key',
    { p_id: id },
  );
  if (error) return { success: false, error: error.message };
  return data ?? { success: false, error: 'empty-response' };
}

export async function listMyApiKeys(): Promise<{
  success: boolean;
  keys: ApiKeyMetadata[];
  error?: string;
}> {
  const { data, error } = await callRpc<ApiKeyMetadata[]>('list_my_api_keys');
  if (error) return { success: false, keys: [], error: error.message };
  return { success: true, keys: data ?? [] };
}
